import React from 'react';
import {ExpandableUsefulLinkItemComponent} from "../../../../components/useful-links/parts/useful-link-item/expandable-useful-link-item.component";
import {MenuItemRendererBase} from "../../../menu-items-common/renderer/menu-item-renderer-base";
import {ExpandableMenuItemConfig} from '../../../menu-items-common/expandable/expandable-menu-item.interface';
import {IMenuItemConfigReader} from '../../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface';
import {IServiceFactoryExtended} from '../../../service-factory-extended.interface';
import {IRenderMenuItemOptions} from '../../../menu-items-common/renderer/menu-item.renderer.interface';

export class GenericExpandableUsefulLinksMenuItemRenderer extends MenuItemRendererBase {
    constructor(public readonly expandableKey: ExpandableMenuItemConfig,
        configReader: IMenuItemConfigReader,
        services: IServiceFactoryExtended
    ) {
        super(expandableKey.menuItemKey, configReader, services)
    }
    protected _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement {
        return (<ExpandableUsefulLinkItemComponent
            key={this.key}
            menuItem={this}
            showSeparator={options.showSeparator}
            subItems={this.expandableKey.subItems}
            onSubItemClick={options.onBeforeClick}
        />);
    }
}